/*
 * Broadcast Theme
 *
 * Use this file to add custom Javascript to Broadcast.  Keeping your custom
 * Javascript in this fill will make it easier to update Broadcast. In order
 * to use this file you will need to open layout/theme.liquid and uncomment
 * the custom.js script import line near the bottom of the file.
 */

  // Fix for product quick-add modal slider initialization
  (function() {
    // Listen for when quick-add modal opens to initialize OrderGroove
    document.addEventListener('click', function(e) {
      var quickAddToggle = e.target.closest('[data-quick-add-modal-toggle]');
      if (quickAddToggle) {
        setTimeout(function() {
          initOrderGrooveInModal();
        }, 500);
      }
    });
    
    // Listen for variant changes in quick-add modal
    document.addEventListener('change', function(e) {
      if (e.target.matches('[data-single-option-selector]')) {
        var modal = e.target.closest('[data-quick-add-modal]');
        if (modal) {
          setTimeout(function() {
            updateSliderInModal(modal);
            updatePriceInModal(modal);
            initOrderGrooveInModal(); // Reinit OrderGroove on variant change
          }, 50);
        }
      }
    });
    
    function initOrderGrooveInModal() {
      // Update variant ID in OrderGroove containers when variant changes
      var modals = document.querySelectorAll('[data-quick-add-modal]');
      modals.forEach(function(modal) {
        var variantIdInput = modal.querySelector('input[name="id"]');
        var ogContainer = modal.querySelector('[data-og-offer]');
        
        if (variantIdInput && ogContainer) {
          var variantId = variantIdInput.value;
          ogContainer.setAttribute('data-variant-id', variantId);
        }
      });
      
      // Check if OrderGroove is loaded
      if (typeof window.OG !== 'undefined') {
        try {
          if (window.OG.refresh) {
            // Refresh OrderGroove to detect new products in the modal
            window.OG.refresh();
            console.log('OrderGroove refreshed for quick-add modal');
          }
        } catch (e) {
          console.warn('OrderGroove refresh error:', e);
        }
      } else if (typeof window.ordergroove !== 'undefined') {
        try {
          if (window.ordergroove.init) {
            window.ordergroove.init();
            console.log('OrderGroove initialized for quick-add modal');
          } else if (window.ordergroove.refresh) {
            window.ordergroove.refresh();
            console.log('OrderGroove refreshed for quick-add modal');
          }
        } catch (e) {
          console.warn('OrderGroove init error:', e);
        }
      } else {
        console.log('OrderGroove not detected - subscription widget may not be available');
      }
    }
    
    function updatePriceInModal(modal) {
      var variantIdInput = modal.querySelector('input[name="id"]');
      var selectedVariantId = variantIdInput ? variantIdInput.value : null;
      
      if (!selectedVariantId) return;
      
      // Get product JSON
      var productJson = modal.querySelector('[data-product-json]');
      if (!productJson) return;
      
      var product = null;
      try {
        product = JSON.parse(productJson.textContent);
      } catch (e) {
        console.warn('Could not parse product JSON', e);
        return;
      }
      
      // Find the selected variant
      var selectedVariant = product.variants.find(function(v) {
        return v.id.toString() === selectedVariantId.toString();
      });
      
      if (!selectedVariant) return;
      
      // Format price using Shopify's money format
      var moneyFormat = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}';
      
      function formatMoney(cents) {
        if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
          return Shopify.formatMoney(cents, moneyFormat);
        }
        // Fallback formatting
        var dollars = (cents / 100).toFixed(2);
        return moneyFormat.replace('{{amount}}', dollars).replace('{{amount_no_decimals}}', Math.round(cents / 100));
      }
      
      // Update main price
      var priceElement = modal.querySelector('[data-product-price]');
      if (priceElement) {
        priceElement.innerHTML = selectedVariant.price === 0 ? 
          (window.theme && window.theme.strings && window.theme.strings.free ? window.theme.strings.free : 'Free') : 
          formatMoney(selectedVariant.price);
        
        // Update sale class
        if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
          priceElement.classList.add('product__price--sale');
        } else {
          priceElement.classList.remove('product__price--sale');
        }
      }
      
      // Update compare at price
      var compareElement = modal.querySelector('[data-compare-price]');
      if (compareElement) {
        if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
          compareElement.textContent = formatMoney(selectedVariant.compare_at_price);
          compareElement.style.display = '';
        } else {
          compareElement.style.display = 'none';
        }
      }
      
      // Update BBCOM Member price (10% off)
      var bfPriceElement = modal.querySelector('[data-bf-price]');
      if (bfPriceElement && window.bfQ) {
        var discountedPrice = selectedVariant.price * 0.9;
        bfPriceElement.textContent = formatMoney(Math.round(discountedPrice));
      }
      
      // Update per serving price
      var perServingElements = modal.querySelectorAll('[data-per-serving] div');
      if (perServingElements.length > 0 && window.servingsArray) {
        var servingData = window.servingsArray.find(function(item) {
          return item.id === selectedVariant.id;
        });
        
        if (servingData && servingData.servings) {
          var pricePerServing = selectedVariant.price / servingData.servings;
          var formattedPerServing = formatMoney(Math.round(pricePerServing));
          
          perServingElements.forEach(function(elem) {
            elem.textContent = formattedPerServing;
          });
          
          // Update BF per serving if exists
          if (window.bfQ) {
            var bfPerServing = (selectedVariant.price * 0.9) / servingData.servings;
            var bfPerServingElement = modal.querySelector('#bfperServing div');
            if (bfPerServingElement) {
              bfPerServingElement.textContent = formatMoney(Math.round(bfPerServing));
            }
          }
        }
      }
      
      // Update unit price if it exists
      var unitPriceElement = modal.querySelector('[data-product-unit-price]');
      if (unitPriceElement && selectedVariant.unit_price) {
        unitPriceElement.textContent = formatMoney(selectedVariant.unit_price);
      }
      
      // Update availability
      var addToCartButton = modal.querySelector('button[name="add"]');
      if (addToCartButton) {
        if (selectedVariant.available) {
          addToCartButton.disabled = false;
          var buttonText = addToCartButton.querySelector('span');
          if (buttonText && window.theme && window.theme.strings) {
            buttonText.textContent = window.theme.strings.addToCart || 'Add to cart';
          }
        } else {
          addToCartButton.disabled = true;
          var buttonText = addToCartButton.querySelector('span');
          if (buttonText && window.theme && window.theme.strings) {
            buttonText.textContent = window.theme.strings.soldOut || 'Sold out';
          }
        }
      }
    }
    
    function updateSliderInModal(modal) {
      var productImages = modal.querySelector('product-images');
      if (!productImages) return;
      
      var slides = modal.querySelectorAll('.product__slide');
      if (slides.length === 0) return;
      
      // Get the selected variant ID
      var variantIdInput = modal.querySelector('input[name="id"]');
      var selectedVariantId = variantIdInput ? variantIdInput.value : null;
      
      // Get product JSON to find variant's featured media
      var productJson = modal.querySelector('[data-product-json]');
      var product = null;
      var targetMediaId = null;
      
      if (productJson) {
        try {
          product = JSON.parse(productJson.textContent);
        } catch (e) {
          console.warn('Could not parse product JSON', e);
        }
      }
      
      // Find the selected variant and its featured media
      if (product && selectedVariantId) {
        var selectedVariant = product.variants.find(function(v) {
          return v.id.toString() === selectedVariantId.toString();
        });
        
        if (selectedVariant && selectedVariant.featured_media) {
          targetMediaId = selectedVariant.featured_media.id;
        }
      }
      
      // Fallback to data-active-media attribute
      if (!targetMediaId) {
        var activeMediaId = productImages.getAttribute('data-active-media');
        if (activeMediaId) {
          // Extract the numeric ID from the full media ID (e.g., "section-123-456" -> "456")
          var parts = activeMediaId.split('-');
          targetMediaId = parts[parts.length - 1];
        }
      }
      
      if (!targetMediaId) return;
      
      // Update slides
      slides.forEach(function(slide) {
        var slideImageId = slide.getAttribute('data-image-id');
        var slideMediaId = slide.getAttribute('data-media-id');
        
        // Check if this slide matches the target media
        var isMatch = slideImageId === targetMediaId.toString() || 
                      slideMediaId && slideMediaId.includes(targetMediaId.toString());
        
        if (isMatch) {
          // Show this slide
          slide.classList.remove('media--hidden');
          slide.classList.add('media--active');
          
          // Update the data-active-media attribute
          if (slideMediaId) {
            productImages.setAttribute('data-active-media', slideMediaId);
          }
        } else {
          // Hide other slides
          slide.classList.remove('media--active');
          slide.classList.add('media--hidden');
        }
      });
    }
  })();

  // Add global error handler to catch and log errors without breaking the page
  window.addEventListener('error', function(event) {
    // Suppress non-critical errors that don't break functionality
    if (event.message && (event.message.includes('Cannot set properties of null') || 
                          event.message.includes('not found') ||
                          event.message.includes('Variant with ID'))) {
      console.warn('Caught non-critical error:', event.message);
      // Prevent error from showing in console
      event.preventDefault();
      return true;
    }
  });

  // Add observer to reinitialize sliders when quick-add modal content changes
  if (typeof MutationObserver !== 'undefined') {
    var observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1 && node.querySelector && node.querySelector('[data-product-media-list]')) {
              // Product modal content was added, trigger a resize event to reinit sliders
              setTimeout(function() {
                window.dispatchEvent(new Event('resize'));
              }, 100);
            }
          });
        }
      });
    });

    // Observe the document body for changes
    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  // Function to remove the text 'navigational-flavor:'
  function removeText() {
    var elements = document.querySelectorAll(".fs_filter_checkbox_label");
    elements.forEach(function (element) {
      element.textContent = element.textContent.replace(
        "navigational-flavor:",
        ""
      );
    });
  }

  // Execute the removeText function when the window is fully loaded
  window.onload = removeText;

  // Customer address toggle functionality - extracted to function for reuse
  function initAddressToggleFunctionality() {
    // Toggle new address form
    var newAddressToggles = document.querySelectorAll(".address-new-toggle");
    if (newAddressToggles.length > 0) {
      newAddressToggles.forEach(function(toggle) {
        // Remove existing listeners to prevent duplicates
        var newToggle = toggle.cloneNode(true);
        toggle.parentNode.replaceChild(newToggle, toggle);
        
        newToggle.addEventListener("click", function(event) {
          event.preventDefault();
          var newAddressForm = document.getElementById("AddressNewForm");
          if (newAddressForm) {
            if (newAddressForm.classList.contains("hidden")) {
              newAddressForm.classList.remove("hidden");
            } else {
              newAddressForm.classList.add("hidden");
            }
          }
        });
      });
    }

    // Toggle edit address forms
    var editAddressToggles = document.querySelectorAll(".address-edit-toggle");
    if (editAddressToggles.length > 0) {
      editAddressToggles.forEach(function(toggle) {
        // Remove existing listeners to prevent duplicates
        var newToggle = toggle.cloneNode(true);
        toggle.parentNode.replaceChild(newToggle, toggle);
        
        newToggle.addEventListener("click", function(event) {
          event.preventDefault();
          var formId = this.getAttribute("data-form-id");
          var editForm = document.getElementById("EditAddress_" + formId);
          if (editForm) {
            if (editForm.classList.contains("hidden")) {
              editForm.classList.remove("hidden");
            } else {
              editForm.classList.add("hidden");
            }
          }
        });
      });
    }

    // Handle delete address
    var deleteAddressButtons = document.querySelectorAll(".address-delete");
    if (deleteAddressButtons.length > 0) {
      deleteAddressButtons.forEach(function(button) {
        // Remove existing listeners to prevent duplicates
        var newButton = button.cloneNode(true);
        button.parentNode.replaceChild(newButton, button);
        
        newButton.addEventListener("click", function(event) {
          event.preventDefault();
          var confirmMessage = this.getAttribute("data-confirm-message");
          var formId = this.getAttribute("data-form-id");
          
          if (confirm(confirmMessage || "Are you sure you want to delete this address?")) {
            // Create and submit a delete form
            var form = document.createElement("form");
            form.method = "POST";
            form.action = "/account/addresses/" + formId;
            
            var deleteInput = document.createElement("input");
            deleteInput.type = "hidden";
            deleteInput.name = "_method";
            deleteInput.value = "delete";
            form.appendChild(deleteInput);
            
            document.body.appendChild(form);
            form.submit();
          }
        });
      });
    }

    // Initialize country/province selectors for new address form
    var newCountrySelect = document.getElementById("AddressCountryNew");
    if (newCountrySelect && typeof Shopify !== 'undefined' && typeof Shopify.CountryProvinceSelector !== 'undefined') {
      new Shopify.CountryProvinceSelector(
        "AddressCountryNew",
        "AddressProvinceNew",
        {
          hideElement: "AddressProvinceContainerNew"
        }
      );
    }

    // Initialize country/province selectors for edit address forms
    var editCountrySelects = document.querySelectorAll(".address-country-option");
    if (editCountrySelects.length > 0 && typeof Shopify !== 'undefined' && typeof Shopify.CountryProvinceSelector !== 'undefined') {
      editCountrySelects.forEach(function(select) {
        var formId = select.getAttribute("data-form-id");
        new Shopify.CountryProvinceSelector(
          "AddressCountry_" + formId,
          "AddressProvince_" + formId,
          {
            hideElement: "AddressProvinceContainer_" + formId
          }
        );
      });
    }
  }

  // Handle bfcache (back-forward cache) - reinitialize when page is restored from cache
  window.addEventListener("pageshow", function(event) {
    if (event.persisted) {
      // Page was restored from bfcache, reinitialize address functionality
      initAddressToggleFunctionality();
    }
  });

  window.addEventListener("load", function () {
    // ^^ Keep your scripts inside this IIFE function call to
    // avoid leaking your variables into the global scope.
    // Get all <a> elements on the page
    var allLinks = document.getElementsByTagName("a");

    // Iterate through each <a> element
    for (var i = 0; i < allLinks.length; i++) {
      var link = allLinks[i];

      if (link.textContent.includes("Live Chat")) {
        // Add click event listener to the link
        link.addEventListener("click", function (event) {
          event.preventDefault(); // Prevent the default behavior of the link
          var liveChatIcon = document.getElementById("insync-chat-icon-id");
          if (liveChatIcon) {
            liveChatIcon.click();
          }
        });
      }
    }
    // Get all <a> elements on the page
    var aallLinks = document.getElementsByTagName("a");

    // Iterate through each <a> element
    for (var i = 0; i < aallLinks.length; i++) {
      var alink = aallLinks[i];

      // Check if the text content of the link contains "Privacy Policy"
      if (alink.textContent.includes("Privacy Settings")) {
        // Add click event listener to the link
        alink.addEventListener("click", function (event) {
          event.preventDefault(); // Prevent the default behavior of the link

          // Trigger click event on element with id "ot-sdk-btn-floating"
          var floatingButton = document.querySelector(
            ".ot-floating-button__open"
          );
          if (floatingButton) {
            floatingButton.click();
          }
        }); 
      }
    }

    var detailsElement = document.querySelector("header-search-popdown > details");

    if (detailsElement && window.innerWidth <= 768) { // adjust the width as per your requirement
      detailsElement.setAttribute("open", "true");
    }

    // Optionally, update on resize if you want dynamic behavior
    window.addEventListener("resize", function() {
      var detailsEl = document.querySelector("header-search-popdown > details");
      if (detailsEl) {
        if (window.innerWidth <= 768) {
          detailsEl.setAttribute("open", "true");
        } else {
          detailsEl.removeAttribute("open");
        }
      }
    });

    // Initialize address toggle functionality on load
    initAddressToggleFunctionality();
  });
